import React from "react";
import "./simplePageLoader.css";

const SimplePageLoader = ({ label = "Loading…" }) => (
  <div className="simple-page-loader" role="status" aria-live="polite">
    <div className="simple-page-loader__spinner" aria-hidden="true" />
    <p className="simple-page-loader__label">{label}</p>
  </div>
);

export default SimplePageLoader;
